module.exports = __webpack_public_path__ + "images/jan_62c5635aa4f82bb62b177d2cab4f4dc4.jpg";